export default {
  MissingInformationSaveStatus__ACCOUNT_NUMBER: "Rapid Rewards^^®^^/acct #",
  MissingInformationSaveStatus__EMAIL: "Email",
  MissingInformationSaveStatus__HEADING_ERROR: "Something went wrong",
  MissingInformationSaveStatus__HEADING_SUCCESS: "Nice! Your profile is up-to-date!",
  MissingInformationSaveStatus__PHONE: "Phone",
  MissingInformationSaveStatus__SECURITY_CHALLENGE: "Security Questions",
  MissingInformationSaveStatus__SUBHEADING:
    "We're unable to log you in and update your account right now, but you can still complete your purchase and update your account at a later time. We're sorry for the inconvenience.",
  MissingInformationSaveStatus__UPDATES: "Requested updates",
  MissingInformationSaveStatus__USERNAME: "Username",
  MissingInformationSaveStatus__WHATS_CHANGED: "What's changed",
};
